var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "tranparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "tranparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3564 13.4959C29.6364 13.4839 28.9284 13.5079 28.2444 13.5559V10.1839H27.3084C23.1204 10.1839 21.0324 12.0799 20.0004 13.7239C18.9684 12.0799 16.8804 10.1839 12.6924 10.1839H11.7564V13.5559C11.0724 13.4959 10.3644 13.4839 9.64442 13.4959L8.73242 13.5079V27.4759L9.68042 27.4639C16.0404 27.3799 18.7044 29.9719 19.1844 30.4879L19.6164 30.9559H20.3844L20.8164 30.4879C21.2964 29.9599 23.9604 27.3799 30.3204 27.4639L31.2684 27.4759V13.5079L30.3564 13.4959ZM10.5924 25.5919V15.3679C10.9884 15.3799 11.3844 15.4039 11.7564 15.4399V24.2479L12.5364 24.3799C12.5844 24.3919 16.6764 25.0999 18.4044 27.5719C16.7964 26.6239 14.2764 25.6879 10.5924 25.5919ZM19.1004 25.5079C17.3604 23.7919 14.8764 22.9999 13.6284 22.6879V13.9039L13.6524 13.7959C13.6404 13.7959 13.6404 13.7959 13.6284 13.7959V12.0919C17.7924 12.4519 18.8244 15.1759 19.0524 16.0759C19.0524 16.0879 19.0524 16.0999 19.0524 16.1119H19.0644C19.0884 16.1959 19.1004 16.2679 19.1124 16.3159V25.5079H19.1004ZM20.9004 25.5079V16.3159C20.9124 16.2679 20.9244 16.2079 20.9484 16.1119H20.9604C20.9604 16.1119 20.9604 16.0999 20.9604 16.0759C21.1884 15.1759 22.2204 12.4399 26.3844 12.0919V13.7959C26.3724 13.7959 26.3724 13.7959 26.3604 13.7959L26.3844 13.9039V22.6879C25.1244 22.9999 22.6404 23.7919 20.9004 25.5079ZM29.4084 25.5919C25.7244 25.6759 23.2044 26.6239 21.5964 27.5599C23.3244 25.0879 27.4164 24.3799 27.4644 24.3679L28.2444 24.2359V15.4279C28.6284 15.3919 29.0124 15.3679 29.4084 15.3559V25.5919Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationBlack);
export default __webpack_public_path__ + "static/media/educationBlack.30a8ed0ae1f0548eed6b46287e4e2c71.svg";
export { ForwardRef as ReactComponent };